export default {"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};